import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../../shared/services/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    protected authService: AuthService,
    protected router: Router,
  ) {}

  canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    const isLoggedIn = this.authService.isLoggedIn();
    if (isLoggedIn) {
      return true;
    }
    localStorage.removeItem('user');
    this.router.navigate(['login']);
    return false;
  }
}
